export default __webpack_public_path__ + "static/media/sponsor-medina.5dc83c5c.png";